module.exports = __webpack_public_path__ + "img/fb9a82c.svg";